import React, { createContext, useReducer, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";
import Page from "./page/page";
import "../Game.css";
import { STOP_KEY, RESUME_KEY } from "./page/scene";
import Demo from "./MSN Popups/newDemo";
import Demo2 from "./MSN Popups/newDemo2";
import Demo3 from "./MSN Popups/newDemo3";
import Demo4 from "./MSN Popups/newDemo4";
import { randGroup, randDelay, randNotif, UNLVDate } from "../utils";
import firebase from "./page/firebaseConfig";

export const pauseGame = () => {
  const event = new KeyboardEvent("keyup", { which: STOP_KEY });
  dispatchEvent(event);
};

export const resumeGame = () => {
  const event = new KeyboardEvent("keyup", { which: RESUME_KEY });
  dispatchEvent(event);
};

const gameInitState = {
  scores: 0,
  actions: [],
};

const reducer = (state, payload) => {
  return {
    scores: payload.scores,
    actions: payload.actions,
  };
};

export const GameContext = createContext();

const Game = () => {
  const [state, dispatch] = useReducer(reducer, gameInitState);
  const [able1, setAble1] = React.useState(true);
  const [ptr, setPtr] = React.useState("none");
  
  var time_group;
  if (randDelay === 1) {
    time_group = "During Task group";
  } else {
    time_group = "After Task group";
  }
  console.log("Time group is: ", time_group);
  // Changes according to notification group
  // using randNotif variable from utils rather than the notify array 
  var trigger;
  var notification_name;
  if (randNotif === 1) { 
    notification_name = "Low fear / High efficacy";
    trigger = <Demo 
                notification={notification_name}
                score={state.scores}
                action={state.actions}
                time={time_group} />;
  } else if (randNotif === 2) { 
    trigger = <Demo2 
        notification={notification_name}
        score={state.scores}
        action={state.actions}
        time={time_group} />;
    notification_name = "Low fear / Low efficacy";
  } else if (randNotif === 3) { 
    trigger = <Demo3 
        notification={notification_name}
        score={state.scores}
        action={state.actions}
        time={time_group} />;
    notification_name = "High fear / High efficacy";
  } else if (randNotif === 4) { 
    trigger = <Demo4  
        notification={notification_name}
        score={state.scores}
        action={state.actions}
        timep={time_group} />;
    notification_name = "High fear / Low efficacy";
  }
  
  window.onbeforeunload = function () {
    localStorage.clear();
  };
  
  useEffect(() => {
    const timer = setTimeout(() => {
      setAble1(false);
      setPtr("stroke");
    }, 300000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    console.log(state.scores);
    console.log(state.actions);
  }, [state]);
  
  function storeItems() {
    localStorage.setItem("task_score", state.scores);
    localStorage.setItem("time_group", time_group);
    localStorage.setItem("notification_name", notification_name);
  }

  const gamerecord = () => {
    const db = firebase.firestore();
    // This document is meant to keep track of the user's
    // score while interacting with the platform
    db.collection("login_handler")
      .doc(localStorage.getItem("user_id"))
      .collection("AprilGroup1")
      .add({
        worker_id: localStorage.getItem("user_id"),
        unique_id: localStorage.getItem("unique_id"),
        group: randGroup,
        threat: localStorage.getItem("threat"),
        efficacy: localStorage.getItem("efficacy"),
        task_time_DTI: localStorage.getItem("task_time"),
        task_type: localStorage.getItem("task_type"),
        start_time: localStorage.getItem("home_icon_click_time"),
        time_end: UNLVDate(),
        time_MSN_display: localStorage.getItem("msn_start_time"),
        time_respond: localStorage.getItem("time_respond"),
        MSN_accept: localStorage.getItem("msn_accept"),
        security_setting: localStorage.getItem("security_setting"),
        time_setting: localStorage.getItem("setting_change_time"),
        performance_score: parseInt(state.scores)
      })
      .then(function (docRef) {
        console.log("Document written with ID: ", docRef.id);
      })
      .catch(function (error) {
        console.error("Error adding document: ", error);
      });
  };

  return (
    <GameContext.Provider value={{ gameState: state, gameDispatch: dispatch }}>
      <Grid container justifyContent="space-evenly" style={{ position: "absolute", top: "20px" }}>
        <p style={{color:"white", textAlign: "center", padding: 20}}><b>Please interact with this task for 5 minutes. After 5 minutes, the continue button will become active and you can proceed to the next portion of the platform.</b></p>
      </Grid>
      <Page />
      <div>
        <div style={{position:"absolute", bottom:"50px", left: "0", right: "0", marginLeft:"auto", marginRight:"auto",width:"16%"}}>
          <Button style={{textTransform: "none"}} 
            variant="contained" size="small" 
            color="primary"  
            disabled={able1}
            onClick={(randDelay === 1) ? () => gamerecord() : storeItems()} >
            <Link to={(randDelay === 1) ? "/post_survey" : "/after-task"} style={{ color: "white", pointerEvents: ptr }}>
              Continue
            </Link>
          </Button>
        </div>
      </div>
      { (randDelay === 1) ? trigger : <></> }
    </GameContext.Provider>
  );
};

export default Game;
